import { persistCombineReducers } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { routerReducer } from 'store/reduxFirstHistory';
import app from 'reducers/app';
import inventorySlice from 'slices/inventorySlice';
import leadSlice from 'slices/leadSlice';
import unsavedLeadSlice from 'slices/unsavedLeadSlice';
import backendApi from 'slices/backendApi';

const config = {
  key: 'root',
  blacklist: ['router', 'uploads', 'backendApi', 'inventory'],
  storage,
};

const rootReducer = persistCombineReducers(config, {
  app,
  lead: leadSlice.reducer,
  router: routerReducer,
  inventory: inventorySlice.reducer,
  unsavedLead: unsavedLeadSlice.reducer,
  [backendApi.reducerPath]: backendApi.reducer,
});

export default rootReducer;
